import 'stylesheets/adminlte/style.scss'
import 'admin-lte/dist/img/AdminLTELogo.png'
import 'admin-lte/dist/img/user1-128x128.jpg'

import 'admin-lte'
import 'bootstrap'
import 'overlayscrollbars/js/jquery.overlayScrollbars.min'
